// extracted by mini-css-extract-plugin
module.exports = {"container":"info_popup_style-module__container___1ZsYn"};